import http from "../http";
import {queryClient} from "../client";
import {onUnmounted, ref} from "vue";

export function useAuth() {
  const refreshToken = () => http.get('/sanctum/csrf-cookie');
  const login = (email, password) => http.post('/login', {email, password});
  const logout = () => http.post('/logout');
  const register = params => http.post('/register', params);
  const isAuthenticated = ref(false);

  const unsubscribe = queryClient.getQueryCache().subscribe(({query, }) => {
    if (query.queryKey === 'userCurrent' && query.state?.data?.data) {
      isAuthenticated.value = true;
    }
  })

  onUnmounted(() => {
    unsubscribe();
  })

  return {
    register,
    refreshToken,
    login,
    logout,
    isAuthenticated,
  }
}
